import * as React from 'react';
import { useField } from 'formik';
import { InputWrapperWidget } from './inputs';
import { MultipleSelectOptionType, MultipleSelectWidget } from '../select/MultipleSelectWidget';

export interface FormikMultipleSelectWidgetProps {
  label?: string;
  name: string;
  className?: any;
  options: MultipleSelectOptionType[];
  defaultValue?: string[];
  error?: string;
}

export const FormikMultipleSelectWidget: React.FC<FormikMultipleSelectWidgetProps> = (props) => {
  const [field, meta, helpers] = useField(props.name);
  const error = meta.touched && (props.error || meta.error);

  return (
    <InputWrapperWidget className={props.className} label={props.label} error={error}>
      <MultipleSelectWidget
        {...props}
        selected={field.value}
        onSelect={(selected: any) => {
          helpers.setValue(selected);
        }}
      />
    </InputWrapperWidget>
  );
};
